import { Switch } from '@components/core-ui/form-elements/Switch';
import Dots from '@components/icons/Dots.svg';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useModalContext } from '@providers/ModalProvider';
import toast from 'react-hot-toast';
import { SwitchWrapper, Wrapper } from './styles';
import { TProps } from './types';
import { DotsButton } from '@pages/User/BillingAccountDetailsPage/components/SubscriptionsWrapper/Cards/ActiveCard/styles/DotsButton';

export const AutoTopUpCard = ({ className = '', billingAccount, paymentMethods, reloadData }: TProps) => {
  const { openModal } = useModalContext();

  return (
    <Wrapper className={className}>
      <div className="content flex items-center">
        <h2 className="title mr-3">Auto Top Up</h2>
        <SwitchWrapper>
          <Switch checked={billingAccount.autoTopUpSettings?.enabled || false} onChange={() => {}} disabled={true} />
        </SwitchWrapper>
        <DotsButton
          className="dots-button"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            if (!paymentMethods.default) {
              return toast.error('Please set up default payment method');
            }
            openModal(ModalNamesEnum.AutoTopUpSettings, { billingAccount, paymentMethods, reloadData });
          }}
        >
          <Dots />
        </DotsButton>
      </div>

      <div className="info">
        <div className="rate">${(billingAccount.autoTopUpSettings?.rechargeAmount || 0) / 100}</div>
      </div>
      <div className="description">
        When the balance falls below ${(billingAccount.autoTopUpSettings?.lowLimitAmount || 0) / 100}
      </div>
    </Wrapper>
  );
};
